import React from 'react';
import './pages.css';
import Services from '../components/Services';
import { ClipboardCheck, FileText, Wrench, CheckCircle, Monitor, Cpu } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Mecanique = () => {
    const navigate = useNavigate();

    const processSteps = [
        {
            icon: <ClipboardCheck size={40} />,
            title: "Diagnostic",
            description: "Analyse précise de la panne avec nos outils de lecture électronique de dernière génération."
        },
        {
            icon: <FileText size={40} />,
            title: "Devis Transparent",
            description: "Estimation détaillée des travaux. Aucun travail n'est commencé sans votre validation écrite."
        },
        {
            icon: <Wrench size={40} />,
            title: "Réparation",
            description: "Intervention propre et rigoureuse avec des pièces de qualité d'origine ou équivalente."
        },
        {
            icon: <CheckCircle size={40} />,
            title: "Test & Validation",
            description: "Essai routier systématique et validation de chaque point de contrôle avant retrait."
        }
    ];

    return (
        <div className="mechanic-page">
            {/* Section Hero Impact */}
            <section className="mechanic-hero">
                <div className="hero-overlay"></div>
                <div className="hero-content">
                    <span className="hero-badge">Service Expert</span>
                    <h1 className="hero-title">La mécanique <span>de précision,</span><br/>chez vous ou en atelier.</h1>
                    <p className="hero-subtitle">
                        Savoir-faire artisanal et diagnostic moderne<br/>
                        pour la performance de votre véhicule.
                    </p>
                </div>
            </section>

            {/* Accordion List (Step 2) */}
            <Services />

            {/* Section Notre Processus (Step 3) */}
            <section className="process-section">
                <div className="container">
                    <h2 className="section-title">Notre Processus d'Intervention 🔄</h2>
                    <div className="process-grid">
                        {processSteps.map((step, idx) => (
                            <div key={idx} className="process-card">
                                <div className="step-number">{idx + 1}</div>
                                <div className="process-icon">{step.icon}</div>
                                <h3 className="process-title">{step.title}</h3>
                                <p className="process-desc">{step.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


            {/* Section CTA (Step 6) */}
            <section className="cta-banner">
                <div className="cta-overlay"></div>
                <div className="container cta-container">
                    <div className="cta-text">
                        <h2>Besoin d'un devis gratuit pour votre véhicule ?</h2>
                        <p>Nos experts sont prêts à intervenir rapidement, chez vous ou en atelier.</p>
                    </div>
                    <div className="cta-actions">
                        <button className="cta-btn primary" onClick={() => navigate('/contact')}>
                            Prendre Rendez-vous
                        </button>
                        <a href="tel:0600000000" className="cta-btn secondary">
                            Nous Appeler
                        </a>
                    </div>
                </div>
            </section>

            <style jsx>{`
                .mechanic-page {
                    padding-top: 0;
                    background-color: #f8fafc;
                }

                .container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 0 20px;
                }

                .section-title {
                    text-align: center;
                    font-size: 2.3rem;
                    color: #1A365D;
                    margin-bottom: 50px;
                    font-weight: 800;
                }

                .section-title.left-align {
                    text-align: left;
                }

                /* Hero Section Styles */
                .mechanic-hero {
                    position: relative;
                    height: 65vh;
                    min-height: 500px;
                    background: url('/images/mecanique_hero.png') center/cover no-repeat;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    color: white;
                }

                .hero-overlay {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(to top, rgba(26, 36, 47, 0.9), rgba(26, 36, 47, 0.5));
                    z-index: 1;
                }

                .hero-content {
                    position: relative;
                    z-index: 2;
                    max-width: 800px;
                    padding: 0 20px;
                }

                .hero-badge {
                    background: #3b82f6;
                    color: white;
                    padding: 6px 16px;
                    border-radius: 50px;
                    font-weight: 700;
                    font-size: 0.85rem;
                    text-transform: uppercase;
                    letter-spacing: 2px;
                    margin-bottom: 25px;
                    display: inline-block;
                }

                .hero-title {
                    font-size: 3.5rem;
                    font-weight: 900;
                    margin-bottom: 25px;
                    line-height: 1.1;
                }

                .hero-title span { color: #3b82f6; }

                .hero-subtitle {
                    font-size: 1.3rem;
                    font-weight: 400;
                    opacity: 0.9;
                    line-height: 1.6;
                }

                /* Process Section Styles */
                .process-section {
                    padding: 80px 0;
                    background: white;
                }

                .process-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
                    gap: 30px;
                }

                .process-card {
                    position: relative;
                    background: #f8fafc;
                    padding: 40px 30px;
                    border-radius: 16px;
                    text-align: center;
                    transition: all 0.3s ease;
                    border: 1px solid #e2e8f0;
                }

                .process-card:hover {
                    transform: translateY(-10px);
                    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
                    border-color: #3b82f6;
                }

                .step-number {
                    position: absolute;
                    top: 20px;
                    right: 20px;
                    font-size: 3rem;
                    font-weight: 800;
                    color: #dee2e6;
                    opacity: 0.5;
                    line-height: 1;
                }

                .process-icon {
                    color: #3b82f6;
                    margin-bottom: 20px;
                    display: inline-block;
                }

                .process-title {
                    color: #1A365D;
                    font-size: 1.4rem;
                    font-weight: 700;
                    margin-bottom: 15px;
                }

                .process-desc {
                    color: #64748b;
                    line-height: 1.6;
                }

                /* Expertise Section Styles */
                .expertise-section {
                    padding: 100px 0;
                    background: #f1f5f9;
                }

                .expertise-grid {
                    display: grid;
                    grid-template-columns: 1.2fr 0.8fr;
                    gap: 60px;
                    align-items: center;
                }

                .expertise-main-text {
                    font-size: 1.2rem;
                    color: #475569;
                    margin-bottom: 40px;
                    line-height: 1.8;
                }

                .expertise-features {
                    display: grid;
                    gap: 30px;
                }

                .expertise-item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    gap: 15px;
                }

                .item-icon {
                    color: #3b82f6;
                    margin-bottom: 5px;
                }

                .expertise-item h4 {
                    color: #1A365D;
                    font-size: 1.2rem;
                    margin-bottom: 8px;
                }

                .expertise-item p {
                    color: #64748b;
                    font-size: 0.95rem;
                }

                .expertise-visual {
                    display: grid;
                    grid-template-columns: 1fr;
                    gap: 20px;
                }

                .stat-card {
                    background: white;
                    padding: 30px;
                    border-radius: 16px;
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
                    text-align: center;
                }

                .stat-card.blue {
                    background: #1A365D;
                    color: white;
                }

                .stat-number {
                    display: block;
                    font-size: 2.5rem;
                    font-weight: 800;
                    margin-bottom: 5px;
                }

                .stat-label {
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                }

                /* CTA Banner Styles */
                .cta-banner {
                    position: relative;
                    padding: 100px 0;
                    background: url('/images/mecanique_hero.png') center/cover no-repeat fixed;
                    color: white;
                    overflow: hidden;
                }

                .cta-overlay {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: #1A365D;
                    opacity: 0.92;
                }

                .cta-container {
                    position: relative;
                    z-index: 2;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 40px;
                }

                .cta-text h2 {
                    font-size: 2.5rem;
                    font-weight: 800;
                    margin-bottom: 15px;
                }

                .cta-text p {
                    font-size: 1.2rem;
                    opacity: 0.9;
                }

                .cta-actions {
                    display: flex;
                    gap: 20px;
                    flex-shrink: 0;
                }

                .cta-btn {
                    padding: 18px 35px;
                    border-radius: 4px;
                    font-weight: 700;
                    text-transform: uppercase;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    font-size: 0.95rem;
                }

                .cta-btn.primary {
                    background: white;
                    color: #1A365D;
                    border: none;
                }

                .cta-btn.primary:hover {
                    background: #f8fafc;
                    transform: translateY(-3px);
                    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
                }

                .cta-btn.secondary {
                    background: transparent;
                    color: white;
                    border: 2px solid white;
                    text-decoration: none;
                    text-align: center;
                }

                .cta-btn.secondary:hover {
                    background: rgba(255, 255, 255, 0.1);
                    transform: translateY(-3px);
                }

                @media (max-width: 992px) {
                    .expertise-grid, .cta-container {
                        grid-template-columns: 1fr;
                        text-align: center;
                    }
                    .section-title.left-align {
                        text-align: center;
                    }
                    .cta-actions {
                        justify-content: center;
                    }
                }

                @media (max-width: 768px) {
                    .hero-title { font-size: 2rem; }
                    .cta-text h2 { font-size: 2rem; }
                    .section-title { font-size: 1.8rem; }
                }
            `}</style>
        </div>
    );
};

export default Mecanique;
